import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const listRoutes = [
  {
    path: "lists",
    loader: protectedRouteLoader,
    lazy: async () => {
      const [layoutMod, errorMod] = await Promise.all([
        import("components/UI/AdminLayout"),
        import("views/ErrorPage"),
      ]);

      const AdminLayout = layoutMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const mod = await import("views/Lists/get-list");
          const ShowList = mod.ShowList;

          return {
            Component: () => <ShowList />,
          };
        },
      },
      {
        path: "details/:listId",
        lazy: async () => {
          const mod = await import("views/Lists/list-details");
          const ListDetails = mod.ListDetails;

          return {
            Component: () => <ListDetails />,
          };
        },
      },
      {
        path: "tags/:tagId",
        lazy: async () => {
          const mod = await import("views/Lists/tag-details");
          const TagDetails = mod.TagDetails;

          return {
            Component: () => <TagDetails />,
          };
        },
      },
    ],
  },
];
